import { getOwnerRpc } from 'growth-monetization-service-types';
import { rpcClient } from '../client';
import { getProductInventoryRpc } from '../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc';
export const fetchOwners = () => rpcClient.call(getOwnerRpc, {});
export const fetchProductInventory = () => {
  return rpcClient.call(getProductInventoryRpc, {}).then(response => response.products);
};